// extracted by mini-css-extract-plugin
export default {"inputForm":"StringInput_inputForm__EMBwF","isError":"StringInput_isError__8kOgq","errorMessage":"StringInput_errorMessage__QY4tQ"};